import script from "./CreatorEditorFeatureSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorEditorFeatureSelect.vue?vue&type=script&setup=true&lang=js"

import "./CreatorEditorFeatureSelect.vue?vue&type=style&index=0&id=e8b2a952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8b2a952"]])

export default __exports__